<template>
  <AtomsCalculatorFrame
    iframe-class="!mx-auto"
    :type="type"
    :src="src"
  />
</template>

<script>
export default {
  name: 'MoleculesCalculatorDeposit',

  data: () => ({
    type: 'How_Much_to_Deposit_Calculator',
    src: '//www.visionabacus.net/Tools/B3/SuiteA/G200/How_Much_to_Deposit_Calculator/CompareClub'
  })
}
</script>
